module.exports = __webpack_public_path__ + "img/iconSystemRolePermission.132376f8.svg";